import gql from 'graphql-tag';

export class ActivitySaleFragment {
    static enteteDevisModelFragment = gql`
        fragment enteteDevisModel on EnteteDevisCommandeForVentesModeleDTO {
            IdDevisCommande
            IdActivite
            DateDevisCommande
            IdBenef
            IdExercice
            MontantFraisPort
            MontantRemise
            NumChoixLocation
            ObjetDevisCommande
            RemarquePriveeDevisCommande
            RemarquePubliqueDevisCommande
            HaveFormulaireParametre
        }`;

    static retourMoteurFragment = gql`
        fragment retourMoteurModel on RetourMoteurModelDTO {
            Accepte
            MessageRefusAccessibilite
            Type
            ForcageAutorise
            QuantiteAccepte
            QuantiteMaximum
            QuantiteNonSubventionnee
            AutorisationQuantiteSansSubvention
            SubventionComplementaireMaxiAvecNonSubventionnes
            SubventionComplementaireMaxiAvecForcage
            SubventionComplementaireMaxiAcceptee
            AppelMoteur
            ListeSubventionsAccordees {
                anyType
            }
            SubventionAccordeeEnCours
        }
    `;

    static ligneDevisModelFragment = gql`
        fragment ligneDevisModel on LigneDevisModeleDTO {
            IdLigneDevisCommande
            IdProduit
            CodeStatutLigne
            CodeHistoStatut
            APayer
            SubUnitaire
            SubUnitTheorique
            SubTotale
            SubTotaleTheorique
            RemarquePrivee
            RemarquePublique
            Quantite
            QuantiteLivree
            QuantiteALivree
            PVU
            PVUSubDeduite
            CodeModeLivraison
            LibelleModeLivraison
            IsLigneLivree
            CodeStatutFacture
            DateReapproLigne
            HaveFormulaireParametre
            IdCourrier
            #Article
            IdArticle
            ReferenceCommande
            LibelleArticle
            LibelleLigne
            IsArticleUnitaire
            PrixVenteActuel
            IsArticleUniqueParCommande
            MontantAcompteDefaut
            IsArticleReapproOuNotCanLivre
            #Produit
            LibelleProduit
            ProduitSeCommandeSeule
            isFacturationCentraliseeSurProduit
            #Spécifique Groupe
            IdBenefLigne
            BenefNomPrenom
            IsArticleGrpNominatif
            #Spécifique Location
            IsOptionLocation
            IsOptionObligatoireLocation
            IsLocationDisponible
            CapaciteMin
            CapaciteMax
            DateDebutLocation
            DateFinLocation
            IsGererParticipant
            # Spécifique Cotisations
            DateDebutCotisation
            DateFinCotisation
            # Spécifique Chèque et Bons
            IsArticleChequierDynamique
            EnteteDevisModel {
                ...enteteDevisModel
            }
            RetourMoteurModel {
                ...retourMoteurModel
            }
            SessionChoixModel {
                IdArticleOrigine
                IdBenefOrigine
                IdSession
                Libelle
                ListNumeroChoix {
                    NumeroChoixModelDTO {
                        IdCommandeConcernee
                        IdCommandeEnCours
                        LibelleCMD
                        Numero
                    }
                }
                MaxNum
                NumPremierChoixDispo
            }
            LibelleOptionAjoute
        }
        ${ActivitySaleFragment.enteteDevisModelFragment}
        ${ActivitySaleFragment.retourMoteurFragment}
    `;

    static articleVenteModel = gql`
        fragment articleVenteModel on ArticleVenteModeleDTO {
            # Article
            IdArticle
            LibelleArticle
            CodeBarreArticle
            PrixVenteActuel
            Quantite
            QuantiteDisponible
            QuantiteMinimum
            HaveFormulaireSurLigne
            Picto {
                PictoFullUrl
            }
            IsArticleReappo
            # Produit
            IdProduit
            LibelleProduit
            IsProduitSeCommandeSeule
            # Famille
            LibelleFamille
            # Gestion en stock
            IsNotGereEnStock
            CodeFonctionnementProduit
            IsGenerique
            # Spécifique Chèque et Bons
            IsChequierDynamique
            IsChequierDynamiqueConnect
            # Spécifique Location
            IsArticleLoc
            IsOptionLocation
            SessionChoix
            DateDebutLocation
            DateFinLocation
            IsGererParticipant
            CapaciteMin
            CapaciteMax
            IsObligatoireLocation
            IsArticleUnitaire
            # Spécifique Groupe
            IsNominatif
            IsArticleUniqueParCommande
        }
    `;

    static ventesClientModelFragment = gql`
        fragment ventesClientModel on VentesClientsModeleDTO{
            IdBenef
            IsPaiementDifeereAutoriseGestion
            IdCompteCBDelegation
            IdJournal
            ListeMoyenPaiementModele {
                MoyenPaiementForVenteModeleDTO {
                    IdMoyenPaiement
                    CodeMoyenPaiement
                    LibelleMoyenPaiement
                }
            }
            IsFactureCentralisee
            IsCotisation
            IsLocation
            IsInscriptionGrp
            IsVente
            IsChqBons
            IdCompteCBDelegation
            HasProduitWithModalitesReglement
            EnteteDevisModel {
                ...enteteDevisModel
            }
            ListeLigneDevisModel {
                LigneDevisModeleDTO {
                    ...ligneDevisModel
                }
            }
            # Spécifique Groupe et Location
            ModalitesReglementAffichage {
                EcheancierLibelle
                MoyenPaiementLibelle
            }
            ListeArticleModele {
                ArticleVenteModeleDTO {
                    ...articleVenteModel
                }
            }
            sessionChoixModel {
                IdArticleOrigine
                IdBenefOrigine
                IdSession
                Libelle
                ListNumeroChoix {
                    NumeroChoixModelDTO {
                        IdCommandeConcernee
                        IdCommandeEnCours
                        LibelleCMD
                        Numero
                    }
                }
                MaxNum
                NumPremierChoixDispo
            }
        }
        ${ActivitySaleFragment.ligneDevisModelFragment}
        ${ActivitySaleFragment.articleVenteModel}
    `;

    static statusAdministratifOrLivraison = gql`
        fragment statusAdministratifOrLivraison on StatutCommandeDTO {
            Id
            Libelle
            Couleur
            Code
        }
    `;
}
